import type { PropsWithChildren } from 'react';
import { Box, Container, type Theme } from '@mui/material';
import AnimatedGradient from './AnimatedGradient';

export const participantContentSx = (theme: Theme) => ({
    width: '100%',
    maxWidth: { xs: '100%', lg: theme.breakpoints.values.lg, xl: theme.spacing(170) },
    py: { xs: 2.5, md: 3.5 },
    position: 'relative',
    zIndex: 1,
    flex: 1,
    minWidth: 0,
    mx: 'auto',
} as const);

export function ParticipantPage({ children }: PropsWithChildren) {
    return <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', position: 'relative', bgcolor: 'background.default' }}>
        <AnimatedGradient duration={20} opacity={0.1} />
        <Container maxWidth={false} sx={participantContentSx}>{children}</Container>
    </Box>;
}